module.exports = __webpack_public_path__ + "img/bg-mockup.096e9b83.png";